import { MantineProvider, createTheme } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { Notifications } from '@mantine/notifications';
import 'dayjs/locale/fr';
import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/tiptap/styles.css';
import '@mantine/notifications/styles.css';
import '@gfazioli/mantine-video/styles.css';

const defaultTheme = createTheme({});

/* `withNotifications={false}` pour un provider imbriqué (canvas Puck) : le
   store des notifications est global, un second <Notifications /> afficherait
   chaque notification une seconde fois. */
export const WebMantineProvider = ({ theme, withNotifications = true, children }) => (
  <MantineProvider theme={theme ?? defaultTheme}>
    <DatesProvider settings={{ locale: 'fr', firstDayOfWeek: 1 }}>
      {withNotifications && <Notifications position="top-center" />}
      {children}
    </DatesProvider>
  </MantineProvider>
);
